<template>
  <div class="serch_box">
    <div class="crumbs"><span style="color: #666666">当前位置：产品中心></span> {{ $route.query.cate_name }}</div>
    <div class="search_ho">搜索结果：<span style="color: #0092DD">{{total}}</span> 结果</div>
    <div class="cutr_content" v-if="$route.query.cate_name=='品牌产品'">
      <div class="in_for_tan animate__animated animate__slow" :class="{'animate__fadeInUp':item.anmintes}" @click="changDetails(item.id)" v-for="(item,index) in productList" :key="index">
        <div class="foy_item">
          <div class="img_box">
            <img v-lazy="item.image[0]">
          </div>
          <div class="lines"></div>
          <div class="intro">
            <div class="names">{{ item.name }}</div>
            <div class="txt_lines"></div>
            <div class="tips">药品信息：</div>
            <div class="intro_mess tbs">
              <span>规格：{{ item.spec }}</span><span>包装： {{ item.pack }}</span>
            </div>
            <div class="intro_mess many-txt-line">{{ item.intro }}</div>
          </div>
          <div class="see">
            <img class="img" src="../../assets/product/see.png"/>
            <img class="active_img" src="../../assets/product/seeactive.png"/>
            <div class="opctive">查看详情</div>
          </div>
        </div>
      </div>
    </div>
    <div class="more_cutr_content" v-else>
      <div class="in_for_tan animate__animated animate__slow" :class="{'animate__fadeInUp':item.anmintes}" v-for="(item,index) in productList" :key="index">
        <div class="foy_item">
          <div class="img_box">
            <div class="names">{{ item.name }}</div>
            <div class="txt_lines"></div>
          </div>
          <div class="lines"></div>
          <div class="intro">
            <div class="tips">药品信息：</div>
            <div class="intro_mess tbs">
              <span>规格：{{ item.spec }}</span>
            </div>
            <div class="intro_mess tuns many-txt-line" :class="{'active_tuns':item.chengNum}">{{ item.intro }}</div>
          </div>
          <div class="see">
            <img @click="changHeight(index)" v-if=" item.clickou" class="img" src="../../assets/product/see.png"/>
            <img @click="changUnHeight(index)" v-else class="active_img" src="../../assets/product/active_op.png"/>
          </div>
        </div>
      </div>
    </div>
    <div class="block_pagination block_pc" v-if="total">
      <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-size="6"
          :pager-count="7"
          layout="prev, pager, next, total,jumper"
          :total="total">
      </el-pagination>
    </div>
    <div class="block_pagination block_wap" v-if="total">
      <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-size="6"
          :pager-count="5"
          layout="prev, pager, next"
          :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getProductList, getProductMoreList} from "../../api/apis";

export default {
  name: "produceSearch",
  data(){
    return{
      productList:[],
      total:0,
      page:1,
      group_id:'',
      name:''
    }
  },
  watch:{
    $route(to,from){
      if(to.query.name!=from.query.name){
        if(to.query.group_id){
          this.group_id = to.query.group_id
        }
        this.name = to.query.name
        this.changProduct()
      }
    }
  },
  created() {
     if(this.$route.query.group_id){
        this.group_id = this.$route.query.group_id
       this.name = this.$route.query.name
     }
     if(this.$route.query.cate_name=='品牌产品'){
        this.GetProductList()
     }else {
        this.GetMOreProductList()
     }
    window.addEventListener('scroll', this.handleScroll)
  },
  methods:{
    handleScroll() {
      let scroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (document.body.clientWidth < 1200) {

      }else {
        if (scroll > 135) {
          if( this.productList[0]){
            this.productList[0].anmintes = true
          }
        }
        if (scroll > 384) {
          if( this.productList[1]){
            this.productList[1].anmintes = true
          }
        }
        if (scroll > 638) {
          if( this.productList[2]){
            this.productList[2].anmintes = true
          }
        }
        if (scroll > 890) {
          if( this.productList[3]){
            this.productList[3].anmintes = true
          }
        }
        if (scroll > 1136) {
          if( this.productList[4]){
            this.productList[4].anmintes = true
          }
        }
        if (scroll > 1384) {
          if( this.productList[5]){
            this.productList[5].anmintes = true
          }
        }
      }
      //   this.showNowBtn = true;
      // }
      // if (scroll > 4000) {
      //   this.showSurvey = true;
      // }
      // if (document.body.clientWidth < 1200) {
      //   if (scroll > 2300) {
      //     this.showSurvey = true;
      //   }
      // }
    },
    changProduct(){
      if(this.$route.query.cate_name=='品牌产品'){
        this.GetProductList()
      }else {
        this.GetMOreProductList()
      }
    },
    handleCurrentChange(e) {
      this.page = e
      this.changProduct()
    },
    changDetails(id) {
      this.$router.push({path: '/product/details', query: {detaisId: id}})
    },
    GetProductList() {
      let datas = {
        group_id: this.group_id,
        name: this.name,
        page: this.page,
        limit: 6
      }
      getProductList(datas).then(res => {
        this.productList = res.data.data
        res.data.data.map(item=>{
          item.anmintes = false
        })
        this.total = res.data.total
      })
    },
    changHeight(e) {
      this.productList[e].chengNum = true
      this.productList[e].clickou = !this.productList[e].clickou
    },
    changUnHeight(e) {
      this.productList[e].chengNum = false
      if (this.productList[e].intro.length>=83) {
        this.productList[e].clickou = !this.productList[e].clickou
      }
    },
    GetMOreProductList() {
      let datas = {
        group_id: this.group_id,
        name: this.name,
        page: this.page,
        limit: 2
      }
      getProductMoreList(datas).then(res => {
        res.data.data.map(item => {
          item.chengNum = false
          item.anmintes = false
          if (item.intro.length >= 83) {
            item.clickou = true
          } else {
            item.clickou = false
          }
        })
        this.productList = res.data.data
        this.total = res.data.total
      })
    },
  },
}
</script>

<style scoped lang="less">

.serch_box {
   .search_ho{
     font-size: 18px;
     font-family: Microsoft YaHei;
     font-weight: 400;
     color: #555555;
     margin-top: 30px;
   }
  .crumbs{
    padding: 30px 0 15px;
    border-bottom: 1px solid #DBDBDB;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #0092DD;
    opacity: 1;
  }

  .more_cutr_content {
    margin-top: 30px;

    .in_for_tan {
      min-height: 147px;
      background: #F3F3F3;
      margin-bottom: 30px;
      transition: all 0.3s linear;

      .foy_item {
        padding: 34px 29px 17px;
        display: flex;
        position: relative;

        .img_box {
          width: 126px;
          .names {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
          }

          .txt_lines {
            width: 24px;
            height: 0px;
            border: 2px solid #333333;
            margin: 29px 0 19px;
          }
        }

        .lines {
          width: 0px;
          height: 64px;
          border: 1px solid #707070;
          opacity: 1;
          margin: 0 50px 0 36px;
        }

        .intro {


          .tips {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 28px;
            color: #333333;
            margin-bottom: 15px;
          }

          .intro_mess {
            width: 596px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 300;
            line-height: 22px;
            color: #666666;
            -webkit-line-clamp: 2;
            white-space: pre-wrap;


            span:nth-child(1) {
              margin-right: 110px;
            }
          }

          .tuns {
            max-height: 44px;
            transition: all 0.3s linear;
          }

          .active_tuns {
            max-height: 200px;
            -webkit-line-clamp: 8;
            transition: all 0.3s linear;
          }

          .tbs {
            margin-bottom: 5px;
          }
        }

        .see {
          position: absolute;
          right: 39px;
          bottom: 24px;
          display: flex;
          align-items: center;

          img {
            width: 30px;
            height: 30px;
            margin-right: 15px;
          }

          .active_img {
            width: 30px;
            height: 7px;
          }
        }
      }
    }

    .in_for_tan:hover {
      box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.2);
      transition: all 0.3s linear;

      .foy_item {
        .img_box {
          .names {
            color: #0092DD;
          }

          .txt_lines {
            border-color: #0092DD;
          }
        }

        .opctive {
          display: block;
        }
      }
    }
  }

  .cutr_content {
    margin-top: 30px;

    .in_for_tan {
      min-height: 222px;
      background: #F3F3F3;
      margin-bottom: 30px;
      transition: all 0.3s linear;

      .foy_item {
        padding: 34px 29px 17px;
        display: flex;
        position: relative;

        .img_box {
          width: 214px;
          height: 149px;
          overflow: hidden;
          background: #FFFFFF;

          img {
            width: 100%;
            object-fit: contain;
          }
        }

        .lines {
          width: 0px;
          height: 64px;
          border: 1px solid #707070;
          opacity: 1;
          margin: 0 50px 0 36px;
        }

        .intro {
          .names {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
          }

          .txt_lines {
            width: 24px;
            height: 0px;
            border: 2px solid #333333;
            margin: 29px 0 19px;
          }

          .tips {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 28px;
            color: #333333;
            margin-bottom: 15px;
          }

          .intro_mess {
            width: 596px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 300;
            line-height: 22px;
            color: #666666;
            -webkit-line-clamp: 2;
            white-space: pre-wrap;

            span:nth-child(1) {
              margin-right: 110px;
            }
          }

          .tbs {
            margin-bottom: 5px;
          }
        }

        .see {
          position: absolute;
          right: 39px;
          bottom: 24px;
          display: flex;
          align-items: center;

          img {
            width: 30px;
            height: 30px;
            margin-right: 15px;
          }

          .img {
            display: inline-block;
          }

          .active_img {
            display: none;
          }

          .opctive {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #0092DD;
            display: none;
          }
        }
      }
    }

    .in_for_tan:hover {
      box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.2);
      transition: all 0.3s linear;

      .foy_item {
        .intro {
          .names {
            color: #0092DD;
          }

          .txt_lines {
            border-color: #0092DD;
          }
        }

        .img {
          display: none;
        }

        .active_img {
          display: inline-block;
        }

        .opctive {
          display: block;
        }
      }
    }
  }

  .block_wap {
    display: none;
  }

  .block_pc {
    display: block;
    margin: 90px auto 140px;
  }
}

@media (max-width: 1200px) {
  .serch_box {
    width: 100%;
    padding-top: 0.1px;
    .search_ho{
      margin-top:15px;
      font-size: 9px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #555555;
    }
    .crumbs{
      padding: 15px 0 7px;
      border-bottom: 1px solid #DBDBDB;
      font-size: 10px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #0092DD;
      opacity: 1;
    }

    .more_cutr_content {
      margin-top: 20px;

      .in_for_tan {
        min-height: 111px;
        background: #F3F3F3;
        margin-bottom: 30px;
        transition: all 0.3s linear;

        .foy_item {
          padding: 10px 13px 19px;
          display: flex;
          position: relative;

          .img_box {
            width: 84px;
            .names {
              font-size: 11px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
            }

            .txt_lines {
              width: 12px;
              height: 0px;
              border: 1px solid #333333;
              margin: 9px 0 5px;
            }
          }

          .lines {
            width: 0px;
            height: 32px;
            border: 1px solid #707070;
            opacity: 1;
            margin: 0 13px 0 16px;
          }

          .intro {
            width: 80%;
            .names {
              font-size: 11px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
            }

            .txt_lines {
              width: 12px;
              height: 0px;
              border: 1px solid #333333;
              margin: 9px 0 5px;
            }

            .tips {
              font-size: 7px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 14px;
              color: #333333;
              margin-bottom: 7px;
            }

            .intro_mess {
              width: 191px;
              font-size: 7px;
              font-family: Microsoft YaHei;
              font-weight: 300;
              line-height: 15px;
              color: #666666;

              white-space: pre-wrap;

              span:nth-child(1) {
                margin-right: 30px;
              }
            }

            .tuns {
              width: 100%;
              max-height: 80px;
              -webkit-line-clamp: 5;
              transition: all 0.3s linear;
            }

            .active_tuns {
              max-height: 200px;
              -webkit-line-clamp: 12;
              transition: all 0.3s linear;
            }


            .tbs {
              margin-bottom: 5px;
            }
          }

          .see {
            position: absolute;
            right: 44px;
            bottom: 6px;
            display: flex;
            align-items: center;

            img {
              width: 11px;
              height: 11px;
              margin-right: 4px;
            }

            .active_img {
              width: 11px;
              height: 3px;
            }
          }
        }
      }

      .in_for_tan:hover {
        box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.2);
        transition: all 0.3s linear;

        .foy_item {
          .img_box {
            .names {
              color: #0092DD;
            }

            .txt_lines {
              border-color: #0092DD;
            }
          }
        }
      }
    }

    .cutr_content {
      margin-top: 20px;

      .in_for_tan {
        min-height: 111px;
        background: #F3F3F3;
        margin-bottom: 30px;
        transition: all 0.3s linear;

        .foy_item {
          padding: 10px 13px 19px;
          display: flex;
          position: relative;

          .img_box {
            width: 71px;
            height: 50px;
            overflow: hidden;
            background: #FFFFFF;

            img {
              width: 100%;
              object-fit: contain;
            }
          }

          .lines {
            width: 0px;
            height: 32px;
            border: 1px solid #707070;
            opacity: 1;
            margin: 0 13px 0 16px;
          }

          .intro {
            .names {
              font-size: 11px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
            }

            .txt_lines {
              width: 12px;
              height: 0px;
              border: 1px solid #333333;
              margin: 9px 0 5px;
            }

            .tips {
              font-size: 7px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 14px;
              color: #333333;
              margin-bottom: 7px;
            }

            .intro_mess {
              width: 191px;
              font-size: 7px;
              font-family: Microsoft YaHei;
              font-weight: 300;
              line-height: 15px;
              color: #666666;
              -webkit-line-clamp: 2;
              white-space: pre-wrap;

              span:nth-child(1) {
                margin-right: 30px;
              }
            }

            .tbs {
              margin-bottom: 5px;
            }
          }

          .see {
            position: absolute;
            right: 10px;
            bottom: 6px;
            display: flex;
            align-items: center;

            img {
              width: 11px;
              height: 11px;
              margin-right: 4px;
            }

            .img {
              display: inline-block;
            }

            .active_img {
              display: none;
            }

            .opctive {
              font-size: 8px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #0092DD;
              display: none;
            }
          }
        }
      }

      .in_for_tan:hover {
        box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.2);
        transition: all 0.3s linear;

        .foy_item {
          .intro {
            .names {
              color: #0092DD;
            }

            .txt_lines {
              border-color: #0092DD;
            }
          }

          .img {
            display: none;
          }

          .active_img {
            display: inline-block;
          }

          .opctive {
            display: block;
          }
        }
      }
    }

    .block_wap {
      display: block;
      margin: 30px auto 50px;
    }

    .block_pc {
      display: none;
    }
  }
}

</style>
